import React from "react"
import { Wrapper } from "./styled"
import Letters from "./letters/Letters"
import Question from "./question/Question"
import Timer from "./timer/Timer"
import Title from "./title/Title"

const GamePanel = ({letters}) => (
  <Wrapper>
    <Title />
    <Question />
    <Letters letters={letters} />
    <Timer />
  </Wrapper>
)

export default GamePanel